import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class TabService {

  constructor() { }

  filterFunction(value: any, search?: string): boolean {
    let match;
    if (value.indexOf(search.toUpperCase()) > -1) {
      match = true;
    }else {
      match = false;
    }
    if (match || search === '') {
      return true;
    } else {
      return false;
    }
  }

  compareFunction(direction: any, a: any, b: any) {
    // Converting strings to lowercase
    if (a < b) {
      return -1 * direction;
     }
     if (a > b) {
       return direction;
     }
    return 0;
  }
}